import React from 'react';
import { Skeleton, Grid, Box } from '@mui/material';
import styled from 'styled-components';

const Container = styled.div`



  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width:100vw;
  overflow:hidden;
  




   
  .banner-skeleton {
 

}

.skeleton_top {
  width: 100vw;
  height: 430px;
  border-radius: 5px;
  background-color: #f0f0f0;
}

.skepeton_top2{
width: 100%;
  
  margin-top: 1rem;
 display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  gap: .5rem;
  padding: 0rem 1rem;
  max-width: 1441px;
  margin-bottom: 1rem;
  


}

.skeletopn__categort__itm{
  display:grid;
  grid-template-columns: repeat(2, 1fr);
  gap: .5rem;
  width: fit-content;
  margin-right:.5rem;
  margin-bottom:.5rem;

}
  .skeletopnright{
  width: 100%;
  height: 100%;
  border-radius: 5px;
  background-color: #f0f0f0;
width: 141px;
aspect-ratio: 1/1;

  }
.skeptop2__left{
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;

}

.skeptop2__right{
flex: 1;
width: 100%;
}

.skeletopnrightr{
flex: 1;
background-color: #f2f2f2;
width: 100%;
height: 100%;
aspect-ratio: 1/1;
}
.skeptopminileft{
display:flex;


}

`;  

const HomePageSkeleton = () => {
  return (
    <Container >
      <div className='banner-skeleton'>
        <Skeleton className='skeleton_top' variant="rectangular"  />
      </div>

      <div className='skepeton_top2'>
            <div className='skeptop2__left'>
           <div className='skeptopminileft'>
             <div  className='skeletopn__categort__itm'>
          <Skeleton variant="rectangular" className='skeletopnright' />
          <Skeleton variant="rectangular" className='skeletopnright' />
          <Skeleton variant="rectangular" className='skeletopnright' />
          <Skeleton variant="rectangular" className='skeletopnright' />
          

        </div>
         <div  className='skeletopn__categort__itm'>
          <Skeleton variant="rectangular" className='skeletopnright' />
          <Skeleton variant="rectangular" className='skeletopnright' />
          <Skeleton variant="rectangular" className='skeletopnright' />
          <Skeleton variant="rectangular" className='skeletopnright' />
          

        </div>
           </div>
           <div className='skeptopminileft'>
  <div  className='skeletopn__categort__itm'>
          <Skeleton variant="rectangular" className='skeletopnright' />
          <Skeleton variant="rectangular" className='skeletopnright' />
          <Skeleton variant="rectangular" className='skeletopnright' />
          <Skeleton variant="rectangular" className='skeletopnright' />
          

        </div>
         <div  className='skeletopn__categort__itm'>
          <Skeleton variant="rectangular" className='skeletopnright' />
          <Skeleton variant="rectangular" className='skeletopnright' />
          <Skeleton variant="rectangular" className='skeletopnright' />
          <Skeleton variant="rectangular" className='skeletopnright' />
          

        </div>
           </div>
            </div>

            <div className='skeptop2__right'>
              <Skeleton variant="rectangular" className='skeletopnrightr' />

            </div>

      </div>
      
    </Container>
  );
};

export default HomePageSkeleton;
